<div id="message-window" class="hidden popup">
    <p id="message-text"></p>
    <button id="close-button">Close</button>
</div>

<style>
    #message-window{
        display: none;
        text-align: center;
        color: red;
        position: absolute;
        top: 35vh;
        left: 35vw;
        width: 20vw;
        height: 10vw;
        z-index: 100;
        padding: 2vh;
        background-color: #eee;
    }
</style>